(function () {
  var cfg = window.dluxNewsletterPopup;
  if (!cfg || !cfg.enabled) return;

  if (document.documentElement.classList.contains('shopify-design-mode')) {
    return;
  }

  function hash(str) {
    var h = 0;
    var i;
    for (i = 0; i < str.length; i++) {
      h = (Math.imul(31, h) + str.charCodeAt(i)) | 0;
    }
    return String(h);
  }

  var contentHash = hash(cfg.contentKey || '');
  // Dismiss key is content-hash-scoped so a new offer/copy re-pitches dismissed users.
  // Success key is global: once a visitor subscribes, they never see the popup again,
  // regardless of future offer changes (they'll learn about new offers via email).
  var dismissKey = 'dlux_nl_dismiss_' + contentHash;
  var successKey = 'dlux_nl_ok';
  var TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

  if (window.localStorage.getItem(successKey) === '1') {
    return;
  }

  var dismissedAt = window.localStorage.getItem(dismissKey);
  if (dismissedAt) {
    var t = parseInt(dismissedAt, 10);
    if (!isNaN(t) && Date.now() - t < TTL_MS) {
      return;
    }
  }

  if (cfg.homeOnly && !cfg.isHome) {
    return;
  }

  var root = document.getElementById('DluxNewsletterPopup');
  if (!root) return;

  var form = root.querySelector('.dlux-newsletter-popup__form');
  var formPanel = root.querySelector('.dlux-newsletter-popup__form-panel');
  var successPanel = root.querySelector('.dlux-newsletter-popup__success');
  var errEl = root.querySelector('.dlux-newsletter-popup__error');
  var emailInput = root.querySelector('#DluxNewsletterPopupEmail');

  function open() {
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dlux-newsletter-popup--open');
    if (emailInput) {
      setTimeout(function () {
        emailInput.focus();
      }, 50);
    }
  }

  function closeRecordDismiss() {
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dlux-newsletter-popup--open');
    try {
      window.localStorage.setItem(dismissKey, String(Date.now()));
    } catch (e) {}
  }

  function showSuccess() {
    if (formPanel) formPanel.hidden = true;
    if (successPanel) successPanel.hidden = false;
    try {
      window.localStorage.setItem(successKey, '1');
    } catch (e) {}
  }

  function setError(msg) {
    if (errEl) {
      errEl.textContent = msg || '';
      errEl.hidden = !msg;
    }
  }

  setTimeout(function () {
    open();
  }, cfg.delayMs || 8000);

  root.addEventListener('click', function (e) {
    var closeTrigger = e.target.closest && e.target.closest('[data-close]');
    if (closeTrigger) {
      closeRecordDismiss();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) {
      closeRecordDismiss();
    }
  });

  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    setError('');
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    // Mark suppression immediately on submit. Once a visitor has typed an email
    // and clicked subscribe, we never re-pitch them on this browser regardless
    // of what the backend response looks like. The previous content-match
    // detector silently failed when Shopify's response markup didn't include
    // the expected success element, leaving the flag unwritten and the popup
    // re-displaying on the next page load.
    try {
      window.localStorage.setItem(successKey, '1');
    } catch (err) {}

    var fd = new FormData(form);
    var action = form.getAttribute('action');
    if (!action) {
      if (submitBtn) submitBtn.disabled = false;
      setError(cfg.errorGeneric);
      return;
    }

    fetch(action, {
      method: 'POST',
      body: fd,
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(function (res) {
        if (res.ok) {
          showSuccess();
        } else {
          setError(cfg.errorGeneric);
        }
      })
      .catch(function () {
        setError(cfg.errorGeneric);
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });
})();
